/* eslint-disable max-len */
import { Pool } from '@goodboydigital/odie';
import { Container, Point, Sprite } from 'pixi.js';

import { Shared } from '../App';
import { Random } from '../utils/Random';

let index = 0;
const frames = [
    'confetti-yellow',
    'confetti-blue',
    'confetti-red',
    'confetti-purple',
];

class ConfettiParticle extends Sprite
{
    public scaleOffset: number;
    public z: number;
    public rotationVelocity: number;
    public velocity: Point;

    constructor()
    {
        super();
        this.texture = Shared.assets.getTexture(frames[index % frames.length]);
        this.anchor.set(0.5);
        this.visible = false;
        this.scaleOffset = 1 + Math.random();
        this.z = Random.range(-100, -50);
        this.velocity = new Point(Random.range(-2, 2), Random.range(4, 6));

        this.rotation = Math.random() * Math.PI * 2;
        this.rotationVelocity = Random.range(-0.2, 0.2);

        index += 1;
    }
}

export default class Confetti extends Container
{
    public particles: ConfettiParticle[];
    public pool: Pool<ConfettiParticle>;
    public maxParticles: number;
    public overallScale: any;
    public count: number;
    public pos: number;
    public w: number;
    public h: number;
    public focalLength: number;
    public emiting = false;

    constructor()
    {
        super();

        this.particles = [];
        this.pool = new Pool(ConfettiParticle);
        this.maxParticles = 300;
        this.overallScale = 1.5;

        this.count = 0;
        this.pos = 0;

        this.w = 200;
        this.h = 200;
        this.focalLength = 150;
    }

    public play(): void
    {
        this.emiting = true;
    }

    public stop(): void
    {
        this.emiting = false;
    }

    update(dt: number): void
    {
        if (!this.visible) return;

        if (this.particles.length < this.maxParticles && this.emiting) this.addParticle();

        let i = this.particles.length;

        while (i--)
        {
            const p = this.particles[i];

            if (!p.visible) continue;

            const scaleRatio = this.focalLength / (this.focalLength + p.z);
            const vx = p.velocity.x * dt;
            const vy = p.velocity.y * dt;

            p.scale.x = p.scale.y = scaleRatio * 0.2 * p.scaleOffset * this.overallScale;// * 0.2// * 0.5;
            p.position.x += vx * scaleRatio * 0.5; // // * 2//  * 1.5;// % 640//+= p.velocity.y;
            p.position.y += vy * scaleRatio * 0.5; //  * 1.5;
            p.scale.y *= Math.sin(p.rotation * 2);
            p.rotation += p.rotationVelocity * dt;

            p.position.x %= this.w;
            if (p.position.x < 0) p.position.x += this.w;

            if (p.y > this.h) this.removeParticle(i);
        }
    }

    private addParticle(): void
    {
        const p = this.pool.get();

        p.x = Math.random() * this.w;
        p.y = 0;
        p.visible = true;
        this.addChild(p);
        this.particles.push(p);
    }

    private removeParticle(i: number): void
    {
        const p = this.particles[i];

        p.visible = false;
        this.particles.splice(i, 1);
        this.pool.return(p);
    }

    public clear(): void
    {
        let i = this.particles.length;

        while (i--) this.removeParticle(i);
    }
}
